import ScheduleCard from './ScheduleCard.vue';

export default ScheduleCard;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecard/index.ts